import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useContext, useState } from 'react';
import UserContext from '~/context/common/UserContext';
import { VdpDispatcherEvent } from '~/native/vdp/dispatchers/constants';
import { getVehicleDetails, isCurrentVehicleFavorited } from '~/selectors';
import useSelector from '~/store/useSelector';
import sendMessageToNative from './sendMessageToNative';

export default function useIsFavoriteDispatcher(): void {
  const { stockNumber, vehicleId } = useSelector(getVehicleDetails);
  const isFavorite = useSelector(isCurrentVehicleFavorited);
  const {
    favorites: { isLoaded: isFavoritesLoaded }
  } = useContext(UserContext);
  const [checkIsFavorite, setCheckIsFavorite] = useState(false);

  // Wait a bit before checking if the vehicle is a favorite because favorites
  // loading happens before the current vehicle is marked a favorite
  useEffectOnce(
    () => {
      const t = window.setTimeout(() => {
        setCheckIsFavorite(true);
      }, 250);

      return () => clearTimeout(t);
    },
    [],
    isFavoritesLoaded
  );

  useEffectOnce(
    () => {
      if (!isFavorite) return;

      sendMessageToNative(VdpDispatcherEvent.IsFavorite, {
        stockNumber,
        vehicleId
      });
    },
    [isFavorite, stockNumber, vehicleId],
    checkIsFavorite
  );
}
